import React, { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import styles from './Search.module.scss';
import { HydratedCurriculumType } from '../../../Common/types/AppConfigTypes';
import { RootState } from 'MyTypes';
import { searchTermSelector } from '../../filterSelectors';
import * as filterActions from '../../filterActions';
import * as listActions from '../../../List/listActions';

interface SearchProps {
    curriculumType: HydratedCurriculumType;
}

const mapStateToProps = (state: RootState) => ({
    activeSearchTerm: searchTermSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            updateSearchTerm: filterActions.updateSearchTerm,
            getSearchList: listActions.getSearchList,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps> &
    SearchProps;

const Search: React.FC<Props> = ({
    curriculumType,
    activeSearchTerm,
    updateSearchTerm,
    getSearchList,
}) => {
    const [currentSearchTerm, setCurrentSearchTerm] = useState(
        activeSearchTerm || '',
    );

    useEffect(() => {
        setCurrentSearchTerm(activeSearchTerm);
    }, [activeSearchTerm, curriculumType]);

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentSearchTerm(event.target.value);
    };

    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        updateSearchTerm(event.target.value);
    };

    const handleSearch = () => {
        getSearchList();
        setCurrentSearchTerm('');
    };

    return (
        <div className={styles.searchContainer}>
            <div className={styles.searchHeader}>
                Search{' '}
                <span className={styles.searchType}>
                    {curriculumType.displayNamePlural ||
                        curriculumType.displayName ||
                        ''}
                </span>
            </div>
            <div className={styles.searchInputPanel}>
                <div className={styles.searchInputContainer}>
                    <label htmlFor={'search-input'}>Search</label>
                    <input
                        id={'search-input'}
                        className={styles.searchInput}
                        type={'text'}
                        placeholder={'Keyword'}
                        onChange={handleOnChange}
                        onBlur={handleOnBlur}
                        value={currentSearchTerm}
                    />
                    <button
                        className={styles.searchButton}
                        onClick={handleSearch}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Capa_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 56.966 56.966"
                        >
                            <path
                                d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
                                fill="#acacac"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);
